/* Rimtek — interactions page d'accueil
   Slider auto, révélation au défilement, onglets, ajout panier AJAX + toast,
   suggestions de recherche prédictive. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Révélation au défilement ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.rt-reveal');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('rt-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('rt-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Slider héro ---------- */
  function initHero(root) {
    var slides = root.querySelectorAll('.rt-hero__slide');
    var dots = root.querySelectorAll('.rt-hero__dot');
    if (slides.length < 2) return;
    var idx = 0, timer = null;
    var speed = (parseInt(root.dataset.speed, 10) || 5) * 1000;

    function show(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('rt-active', k === idx); });
      dots.forEach(function (d, k) { d.classList.toggle('rt-active', k === idx); });
      var content = slides[idx].querySelector('.rt-hero__content');
      if (content && !reduceMotion) {
        content.style.animation = 'none';
        void content.offsetWidth; /* redémarre l'animation */
        content.style.animation = '';
      }
    }
    function play() {
      if (reduceMotion || root.dataset.autoplay === 'false') return;
      stop();
      timer = setInterval(function () { show(idx + 1); }, speed);
    }
    function stop() { if (timer) clearInterval(timer); }

    dots.forEach(function (d, k) {
      d.addEventListener('click', function () { show(k); play(); });
    });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    show(0);
    play();
  }

  /* ---------- Onglets meilleures ventes ---------- */
  function initTabs(root) {
    var tabs = root.querySelectorAll('.rt-tab');
    var panels = root.querySelectorAll('.rt-panel');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) { x.classList.toggle('rt-active', x === t); });
        panels.forEach(function (p) {
          p.classList.toggle('rt-active', p.dataset.panel === t.dataset.tab);
        });
      });
    });
  }

  /* ---------- Toast ---------- */
  var toastTimer = null;
  function toast(msg) {
    var old = document.querySelector('.rt-toast');
    if (old) old.remove();
    if (toastTimer) clearTimeout(toastTimer);
    var el = document.createElement('div');
    el.className = 'rt-toast';
    el.setAttribute('role', 'status');
    el.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 6L9 17l-5-5"></path></svg>';
    el.appendChild(document.createTextNode(msg));
    document.body.appendChild(el);
    toastTimer = setTimeout(function () { el.remove(); }, 2400);
  }

  /* ---------- Ajout au panier ---------- */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-rt-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.add('rt-bump');
          setTimeout(function () { el.classList.remove('rt-bump'); }, 250);
        });
      });
  }

  function initAddToCart() {
    document.addEventListener('click', function (ev) {
      var btn = ev.target.closest('[data-rt-add]');
      if (!btn) return;
      ev.preventDefault();
      var id = btn.getAttribute('data-rt-add');
      var name = btn.getAttribute('data-rt-name') || '';
      btn.disabled = true;
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(id), quantity: 1 })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          updateCartCount();
          toast(name ? name + ' — ajouté au panier' : 'Ajouté au panier');
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        })
        .catch(function () { toast("Impossible d'ajouter cet article"); })
        .finally(function () { btn.disabled = false; });
    });
  }

  /* ---------- Recherche prédictive ---------- */
  function initSearch(root) {
    var input = root.querySelector('input[name="q"]');
    var drop = root.querySelector('.rt-search__drop');
    if (!input || !drop) return;
    var debounce = null;
    var fmt;
    try {
      fmt = new Intl.NumberFormat(document.documentElement.lang || 'fr', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'MRU'
      });
    } catch (e) { fmt = null; }

    function hide() { drop.hidden = true; drop.innerHTML = ''; }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (debounce) clearTimeout(debounce);
      if (!q) { hide(); return; }
      debounce = setTimeout(function () {
        var url = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') +
          'search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=5&resources[options][fields]=title,product_type,variants.title';
        fetch(url)
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            drop.innerHTML = '';
            if (!products.length) {
              var empty = document.createElement('div');
              empty.className = 'rt-search__empty';
              empty.textContent = 'Aucun résultat trouvé';
              drop.appendChild(empty);
            } else {
              products.forEach(function (p) {
                var a = document.createElement('a');
                a.className = 'rt-search__item';
                a.href = p.url;
                var n = document.createElement('span');
                n.className = 'rt-search__item-name';
                n.textContent = p.title;
                var pr = document.createElement('span');
                pr.className = 'rt-search__item-price';
                var val = parseFloat(p.price);
                pr.textContent = fmt && !isNaN(val) ? fmt.format(val) : (p.price || '');
                a.appendChild(n); a.appendChild(pr);
                drop.appendChild(a);
              });
            }
            drop.hidden = false;
          })
          .catch(hide);
      }, 220);
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) hide();
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') hide();
    });
  }

  /* ---------- Init ---------- */
  function init() {
    initReveal();
    document.querySelectorAll('[data-rt-hero]').forEach(initHero);
    document.querySelectorAll('[data-rt-tabs]').forEach(initTabs);
    document.querySelectorAll('[data-rt-search]').forEach(initSearch);
    initAddToCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Ré-init dans l'éditeur de thème */
  document.addEventListener('shopify:section:load', init);
})();
